export default {
      id: "pay_split-usage",
      viewBox: "0 0 74 20",
      url: __webpack_public_path__ + "sprite.svg#pay_split",
      toString: function () {
        return this.url;
      }
    }